import { AnalyzeConstants } from '../../_constants/Analyze/analyze.constants';
import { getTeamFitmentDataService } from '../../_services/Analyze/teamFitment.service';

export const teamFitmentAction = {
    teamFitmentDataAction
}

//OrgAdmin ORG TEAM starts
function teamFitmentDataAction(data,callBack) {
    return dispatch => {
        dispatch(request());
        getTeamFitmentDataService.getTeamFitmentData(data)
            .then(
                res => {
                    dispatch(success(res));
                    callBack != undefined ? callBack(res) : null
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: AnalyzeConstants.REQUEST_TEAM_FITMENT_DATA } }
    function success(res) { return { type: AnalyzeConstants.RECEIVE_TEAM_FITMENT_DATA, res } }
    function failure(error) { return { type: AnalyzeConstants.ERROR_TEAM_FITMENT_DATA, error } }
}


// WEBPACK FOOTER //
// ./src/_actions/Analyze/teamFitmnt.action.js